<template>
    <div class="main">
        <div v-if="!tech">
            <filter-c
                    :categories="this.categories"
                    @changeFilterCategory="filterCategory = $event"
                    @changeWaitingList="waitingList = $event"
            ></filter-c>

            <banner-c></banner-c>

            <category-list-c
                    v-if="!waitingList"
                    :categories_list="this.categories_list"
            ></category-list-c>

            <div v-if="waitingList" class="products">
                <div v-if="loading" class="loading"></div>
                <div class="container">
                    <table class="table">
                        <thead class="thead">
                        <tr>
                            <td></td>
                            <td>Код</td>
                            <td>Наименование</td>
                            <td>Остаток</td>
                            <td class="text-center">Цена тг</td>
                            <td class="text-center">Заказ (колич.)</td>
                            <td class="text-center">Итог</td>
                        </tr>
                        </thead>

                        <tbody class="tbody">
                        <product-tr
                                v-for="(product) in subscribe_products"
                                :product="product"
                                :key="product.id"
                                :waitingIcon=true
                        ></product-tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="text-center mt-5">Технические неполадки. Свяжитесь с менеджером: <a href="tel:+7 747 717 60 60">+7 747 717 60 60</a></div>
        </div>
    </div>
</template>

<script>

    import FilterC from './order/Filter'
    import BannerC from './order/Banner'
    import ProductTr from './order/Product'
    import CategoryListC from './order/CategoryList'
    import {mapActions} from "vuex";

    export default {
        name: "Order",
        data() {
            return {
                users: null,
                filterCategory: 'all',
                categories: null,
                categories_list: null,
                waitingList: false,
                subscribe_products: null,
                loading: false,
                tech: false,
            }
        },

        mounted() {
            this.axios
                .post(this.axios.defaults.baseURL + 'check-issue', {
                    'selected': 'Заказы'
                })
                .then(response => {
                    if(response.data.message == 'issued') {
                        this.tech = true
                    }
                })

                .catch(error => {
                    // console.log(error);
                    // this.errored = true;
                });

            this.axios
                .get(this.axios.defaults.baseURL + 'categories')
                .then(response => {
                    this.categories = response.data.categories;
                    this.categories_list = this.categories;
                })

                .catch(error => {
                    console.log(error);
                    this.errored = true;
                });
        },

        methods: {
            ...mapActions({
                getProductsWithBasketAction: 'pushProductsWithBasket',
            }),

            getCategory() {
                this.categories_list = this.categories
                const cat = this.categories_list.find(category => category.id === this.filterCategory);

                if (cat) {
                    this.categories_list = []
                    this.categories_list.push(cat);
                }
            },

            getSubscribeProducts() {
                this.loading = true;

                this.axios
                    .get(this.axios.defaults.baseURL + 'product_subscribes')
                    .then(response => {
                        // this.subscribe_products = response.data.products;
                        this.getProductsWithBasketAction({products: response.data.products}).then(response => {
                            this.subscribe_products = response
                        })
                    })
                    .catch(error => {
                        console.log(error);
                        this.errored = true;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
        },

        components: {
            FilterC,
            BannerC,
            CategoryListC,
            ProductTr,
        },

        watch: {
            filterCategory: function () {
                this.getCategory()
            },

            waitingList: function () {
                this.getSubscribeProducts();
            }
        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/pages/Order.vue